export default __webpack_public_path__ + "static/media/seedfund.f72accba.svg";